import { render, staticRenderFns } from "./RecommendationDocument.vue?vue&type=template&id=eb2549ea&scoped=true&"
var script = {}
import style0 from "./RecommendationDocument.vue?vue&type=style&index=0&id=eb2549ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2549ea",
  null
  
)

export default component.exports